import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  submitOnEnter(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }

  connect() {
    this.element.addEventListener("turbo:submit-start", () => {
      if (this.hasSubmitTarget) this.submitTarget.disabled = true
    })
    this.element.addEventListener("turbo:submit-end", () => {
      if (this.hasInputTarget) this.inputTarget.value = ""
      if (this.hasSubmitTarget) this.submitTarget.disabled = false
      if (this.hasInputTarget) this.inputTarget.focus()
    })
  }
}
